// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NewsComplaintStateActions {
  export class LoadNewCount {
    public static readonly type = '[NewsComplaintState] Load New Count';
  }
}
